// removed by extract-text-webpack-plugin
module.exports = {"azf":"azf","dashboard-chart-list":"dashboard-chart-list","report-chart":"report-chart","ant-col-8":"ant-col-8"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/azf/dashboard/Index.scss
// module id = 935
// module chunks = 0